/* Maharaja Footer - link columns fold into accordions on phones, and the showroom sketch opens on
   its middle building there. Runs once; re-inits when the section reloads in the theme editor. */
(() => {
  if (window.mmFooterReady) return;
  window.mmFooterReady = true;

  const phone = () => matchMedia('(max-width: 760px)').matches;

  const init = root => {
    if (!root || root.dataset.mfReady) return;
    root.dataset.mfReady = '1';

    const details = [...root.querySelectorAll('.mf-col details')];
    const sync = () => details.forEach(d => {
      if (phone()) { if (!d.dataset.touched) d.open = false; } else d.open = true;
    });
    details.forEach(d => d.querySelector('summary').addEventListener('click', e => {
      if (!phone()) e.preventDefault(); else d.dataset.touched = '1';
    }));

    const mark = root.querySelector('.mf-mark');
    const centre = () => { if (mark) mark.scrollLeft = (mark.scrollWidth - mark.clientWidth) / 2; };

    const onResize = () => { sync(); centre(); };
    onResize();
    addEventListener('resize', onResize);
    root.mfCleanup = () => removeEventListener('resize', onResize);
  };

  const initAll = () => document.querySelectorAll('[data-mm-footer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-mm-footer]')));
  document.addEventListener('shopify:section:unload', e => {
    const root = e.target.querySelector('[data-mm-footer]');
    if (root && root.mfCleanup) root.mfCleanup();
  });
})();
